module.exports = __webpack_public_path__ + "img/ionic-logo-facebook.9744658b.svg";